export default __webpack_public_path__ + "5ca45b194443c089e0b173e4e4acf1a9.svg";